import { Link } from "react-router-dom";
import { ClipboardList, ArrowRight } from "lucide-react";

export default function FreeAssessmentCta() {
  return (
    <section data-testid="free-assessment-cta" className="border-t border-white/10 bg-[#0D0D12] px-6 py-16 md:px-12">
      <div className="mx-auto flex max-w-[1200px] flex-col items-start gap-6 md:flex-row md:items-center md:justify-between">
        <div className="max-w-2xl">
          <span className="text-xs uppercase tracking-[0.4em] text-[#7C3AED]">Start Here</span>
          <h2 className="mt-3 font-display text-3xl uppercase tracking-tight text-white sm:text-4xl">
            Not sure where to begin? Take a free assessment.
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-white/55 md:text-base">
            Three short quizzes — Grades 1–8, Grades 9–12, and General Algebra — show exactly where
            you stand. Your score stays private on your screen, and you can send it to Dr. Louden so
            your first session starts at the right level.
          </p>
        </div>
        <Link
          to="/math-tutoring"
          data-testid="free-assessment-btn"
          className="magnetic-btn inline-flex shrink-0 items-center gap-3 rounded-full bg-[#7C3AED] px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-black"
        >
          <ClipboardList size={18} />
          Take a Free Assessment
          <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  );
}
